import { render, staticRenderFns } from "./position.md?vue&type=template&id=07128682&"
import script from "./position.md?vue&type=script&lang=js&"
export * from "./position.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07128682')) {
      api.createRecord('07128682', component.options)
    } else {
      api.reload('07128682', component.options)
    }
    module.hot.accept("./position.md?vue&type=template&id=07128682&", function () {
      api.rerender('07128682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/plugin/tooltip/position.md"
export default component.exports